class AddOnProducts extends HTMLElement {
  constructor() {
    super();
    this.productForm = null;
    this.addOnOptions = [];
  }

  connectedCallback() {
    document.addEventListener('DOMContentLoaded', () => this.init());
  }

  init() {
    this.productForm = document.querySelector('.product-form form');
    this.addOnOptions = Array.from(this.querySelectorAll('.summary__title'));

    this.addOnOptions.forEach(option => {
      option.addEventListener('click', (e) => this.toggleOption(e, option));
    });
  }

  toggleOption(event, option) {
    event.preventDefault();
    option.classList.toggle('selected');

    const index = option.getAttribute('data-index');
    const variantId = option.getAttribute('data-variant-id');
    const productId = option.getAttribute('data-product-id');
    const idName = `items[${index}][id]`;
    const quantityName = `items[${index}][quantity]`;

    if (option.classList.contains('selected')) {
      this.addHiddenInput(idName, variantId, productId);
      this.addHiddenInput(quantityName, '1');
    } else {
      this.removeInputByName(idName);
      this.removeInputByName(quantityName);
    }

    this.updateSubmitText();
  }

  addHiddenInput(name, value, productId = null) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    if (productId) input.setAttribute('product-id', productId);
    this.productForm.appendChild(input);
  }

  removeInputByName(name) {
    const input = this.productForm.querySelector(`input[name="${name}"]`);
    if (input) input.remove();
  }

  updateSubmitText() {
    const anySelected = this.addOnOptions.some(option => option.classList.contains('selected'));
    document.querySelector('.product-form .product-form__submit > span').innerHTML = anySelected
      ? window.variantStrings.addProductsToCart
      : window.variantStrings.addToCart;
  }
}

customElements.define('add-on-products', AddOnProducts);